import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { JioPhoneCallController } from '@commoncore/controller/JioPhoneCallController';
import { PrivateFolderController } from '@commoncore/controller/PrivateFolderController';
import { TeamFoldersController } from '@commoncore/controller/TeamFoldersController';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { TEAM_FOLDER_ROUTES } from '@commoncore/enums/ROUTES';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { AlbumsController } from '@mainrepo/app/core/controller/AlbumsController';
import { AllFilesController } from '@mainrepo/app/core/controller/AllFilesController';
import { PeoplesTabController } from '@mainrepo/app/core/controller/PeoplesTabController';
import { SharedFilesListController } from '@mainrepo/app/core/controller/SharedFilesListController';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';
import { PreLoginSharedViewController } from '@sharerepo/app/core/controller/PreloginSharedViewController';
import { UnivShareLinkAllFilesController } from '@sharerepo/app/core/controller/UnivShareLinkAllFilesController';

@Component({
  standalone:true,
  selector: "app-context-menu",
  templateUrl: "./context-menu.component.html",
  styleUrls: ["./context-menu.component.css"],
  imports:[CommonModule]
})
export class ContextMenuComponent implements OnInit {
  @Output() setFavorite = new EventEmitter();
  @Output() unSetFavorite = new EventEmitter();
  @Output() restoreItems = new EventEmitter();
  @Output() deleteParmanently = new EventEmitter();
  @Output() setShare = new EventEmitter();

  public universalService: any;
  public listService: any;
  public fileOpsService: any;
  contextMenuService: any;
  contextMenuMobileService:any;
  loggerService:any;
  router: Router;
  controller:any;
  cleverTapEventsService:any;
  shareController: any;
  albumsController:any;
  peopleTabController:any;
  db: IndexedDBModule;
  contextMenuOpsService:any;
  @Output() createFolder = new EventEmitter();

  @ViewChild('contextMenu', {static: false}) contextMenu;
  localStorageService: any;
  sessionStorageService: any;
  constructor(
    public globalService: GlobalService) {
    this.setEnvObjects(this.globalService);
  }

  

  ngOnInit(): void {
    this.fetchContextMenuJSONs()
  }

  async fetchContextMenuJSONs(){
    if(this.universalService.isMobileDevice){
      await this.contextMenuMobileService.fetchJSONContents();
    }else{
      await this.contextMenuService.fetchJSONContents();  
    }
  }


  setEnvObjects(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.fileOpsService = globalService.getFileOperationServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.contextMenuMobileService = globalService.getContextMenuMobileServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.router = globalService.getRouterRef();
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
    this.db = IndexedDBModule.getInstance(globalService);
    this.contextMenuOpsService = globalService.getContextMenuOperationsServiceRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
  }

  downloadItems() {
    AppEvents.globalObservable.next({"downloadItems": true,"files":this.universalService.selectedNodes});
    this.listService.deSelectAll();
  }

  addFavorite(){
    // this.universalService.popUpToBeOpened = "favorite operation"
    var object = this.fileOpsService.addFavorite();
    this.setFavorite.emit(object);
  }
  removeFavorite(){
    // this.universalService.popUpToBeOpened = "unfavorite operation"
    var object = this.fileOpsService.removeFavorite();
    this.unSetFavorite.emit(object);
  }

  stopPropagation(event){
    // event.stopPropagation();
  }

  
  async decideAction(action, event?) {
    var url = window.location.href;
    if(!this.universalService.isMobileDevice){
      this.universalService.operationInProgress = true;
    }
    if(action != 'openPreviewOptions'){
       this.contextMenuService.hideCustomContextMenu() 
    }
    switch (action) {
      case "openFolder":
        this.universalService.selectedNodes = [];
        if(this.universalService.activeRepo == 'main'){
          if(url.includes('sharedbyme')){
            this.controller = SharedFilesListController.getInstance(this.globalService);
            this.router.navigate(['/shared/sharedbyme', this.universalService.selectedFile["objectKey"]]);
          }else if (url.includes('sharedwithme')){
            this.controller = SharedFilesListController.getInstance(this.globalService);
            this.router.navigate(['/shared/sharedwithme', this.universalService.selectedFile["objectKey"]]);
          }else if (url.includes('teamfolders')){
            this.controller = TeamFoldersController.getInstance(this.globalService);
            this.router.navigate(['/teamfolders', this.universalService.selectedFile["objectKey"]], { queryParams: { tfKey: this.universalService.selectedFile["tfKey"] } , queryParamsHandling: 'merge'});
          }else if(url.includes("privatefolder")){
            this.controller = PrivateFolderController.getInstance(this.globalService);
            this.router.navigate(['/privatefolder',this.universalService.selectedFile["objectKey"]] );
          }else if(url.includes("/search/tf")){
            this.sessionStorageService.setCurrentTeamFolder({folderKey:this.universalService.selectedFile["objectKey"],tfKey:this.universalService.currentTeamFolder["tfKey"]});
            this.globalService.getFolderServiceRef().initialiseBreadCrumbs('1', this.universalService.rootTeamFolderName, null);
            this.globalService.getFolderServiceRef().manageBreadCrumbs(this.universalService.currentTeamFolder["objectKey"], this.universalService.currentTeamFolder["tfName"],this.universalService.currentTeamFolder, null);
            this.router.navigate(['/teamfolders', this.universalService.selectedFile.objectKey], { queryParams: { tfKey: this.universalService.currentTeamFolder["tfKey"] } , queryParamsHandling: 'merge'});
            return;
          }else if(url.includes("/jpai")){
            this.controller = JioPhoneCallController.getInstance(this.globalService);
            this.router.navigate(['/jpai',this.universalService.selectedFile["objectKey"]]);
            return;
          }else{
            this.controller = AllFilesController.getInstance(this.globalService)
            this.router.navigate(['/allfiles',this.universalService.selectedFile["objectKey"]] );
          }
          this.controller.openFolder(this.universalService.selectedFile);
        }
        else{
          if(window.location.href.includes('?u')){
            this.controller = UnivShareLinkAllFilesController.getInstance(this.globalService);
            this.controller.openFolder(this.universalService.selectedFile);
          }
          else {
            this.controller = PreLoginSharedViewController.getInstance(this.globalService);
            this.controller.setEnvObjects(this.globalService);
            this.controller.openFolder(this.universalService.selectedFile);
            this.controller.getFiles();
          }
        }
        break;
      case "downloadItems":
        this.downloadItems();
        break;
      case "openPreviewForFile":
        this.cleverTapEventsService.fileOpened(this.universalService.currentTab);
        if(this.universalService.isHorizontalRecentFileAccessedForPreview) {
          this.universalService.recentFilesDataPreview = true;
        }
        this.universalService.openPreview(this.universalService.selectedFile);
        this.db.clearStore("RecentFilesMetadata");  // refresh recent files in all files to latest previewed file
        break;
      case "showFileInfo":
        this.cleverTapEventsService.fileInfoClicked(this.universalService.currentTab);
        AppEvents.optionSelected.next({fileInfo: true});
        this.universalService.showObjectInfo(this.universalService.selectedFile);
        break;
      case "addToJioCloud":
        this.fileOpsService.addtoJioCloud();
        break;
      case "createShareLink":
        this.fileOpsService.createShareLink();
        AppEvents.optionSelected.next({share: true});
        break;
      case "getShareLink":
        this.cleverTapEventsService.publicShareLinkClick(this.universalService.currentTab)
          
        if(this.universalService.userLoggedIn){
          this.enhancedShareLink()
         // this.cleverTapEventsService.onShareGetLinkClick();
        }else{
          this.universalService.openCreateShareLink = true;
        }
        
        break;
      case "shareWithPeople":
        if(event && event.target) {
          if(event.target.title == 'Private share') {
            //this.cleverTapEventsService.onShareAddPeopleClick();
            this.cleverTapEventsService.privateShareClick(this.universalService.currentTab);
          } else if(event.target.title == 'Share') {
            this.cleverTapEventsService.OnShareOptionClick();
          }
        }
        if(this.universalService.selectedNodes.length > 1) { //Multi share option
          this.universalService.popUpToBeOpened = 'multiShareMessagePopUp';
        } else {
          this.universalService.showShareWithPeople = true;
          AppEvents.optionSelected.next({shareWithPeople: true});
        }
        break;
      case "addToAlbum":
        this.fileOpsService.addToAlbum();
        AppEvents.optionSelected.next({addtoalbum:true})
        break;
      case "renameObject":
        this.fileOpsService.renameObject();
        AppEvents.optionSelected.next({rename:true});
        break;
      case "deleteObject":
        this.fileOpsService.deleteItem();
        AppEvents.optionSelected.next({delete: true});
        break;
      case "addFavorite":
        this.addFavorite();
        break;
      case "removeFavorite":
        this.removeFavorite();
        break;
      case "move":
        this.fileOpsService.moveToSelectedPath();
        AppEvents.optionSelected.next({movecopy: true});
        break;
      case "moveToPrivateFolder":
        this.cleverTapEventsService.moveToPf();
        this.fileOpsService.moveObjectToPrivateFolder();
        break;
      case "moveOutOfPF":
        this.cleverTapEventsService.moveOutOfPf();
        this.fileOpsService.moveOutOfPrivateFolder();
        break;
      case "copy":
        this.fileOpsService.copyInSelectedPath();
        AppEvents.optionSelected.next({movecopy: true});
        break;
      case "restore":
        if(this.universalService.selectedTab == "TeamsFolderOperations"){
          this.contextMenuOpsService.restoreTrashedObject(this.universalService.selectedNodes);
        }else{
          this.restoreItems.emit();
        }
        break;
      case "deleteForever":
        // this.deleteParmanently.emit();
        AppEvents.optionSelected.next({deleteforever: true});
        break;
      case 'setAsCoverPic':
        this.albumsController = AlbumsController.getInstance(this.globalService);
        var selectedObject = this.universalService.selectedFile
        this.albumsController.setEnvObjects(this.globalService);
        this.albumsController.setAsCoverPic(selectedObject);
        break;
      case "addHashTag":
        this.universalService.showMoreOptions = false;
        AppEvents.optionSelected.next({addHashTag:true});
        break;
      case "copyLink":
        var sharUrl = this.universalService.selectedFile.shareURL;
        this.controller = SharedFilesListController.getInstance(this.globalService);
        this.controller.enhancedShareImplementation.copyShareLink(sharUrl);
        break;
      case "openManageLink":
        AppEvents.optionSelected.next({showEnhancedShareLink:true});
        break;
      case "deleteSharedLink":
        var shareKey = this.universalService.selectedFile.objectId;
        this.controller = SharedFilesListController.getInstance(this.globalService);
        this.universalService.showLoader = true;
        this.controller.deleteSharedLink(shareKey);
        break;
      case "removeResults":
        AppEvents.peopleTabEvent.next({ showRemoveOptionsPopUp: true });
        break;
      case "setAsCoverPhoto":
        this.peopleTabController = PeoplesTabController.getInstance(this.globalService);
        var selectedObject = this.universalService.selectedFile
        this.peopleTabController.setEnvObjects(this.globalService);
        this.peopleTabController.setAsCoverPhoto(selectedObject);
        break;
      case "uploadFiles":
        this.uploadFiles();
        break;
      case "uploadFolder":
        this.uploadFolder();
        break;
      case "newFolder":
        this.createNewFolder();
        break;
      case 'teamFolderInfo':
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["FOLDER_INFO"],data]);
        break;
      case 'teamFolderTrash':
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["TRASH"],data]);
        break;
      case 'teamsFolderMembers':
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["MEMBERS"],data]);
        break;
      case 'teamFolderSettings':
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["SETTINGS"],data]);
        break;
      case 'teamFolderactivitylog':
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["ACTIVITY_LOG"],data]);
        break;
      case 'teamFolderSharedItems':
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["SHARED_ITEMS"],data]);
        break;
      case "teamsFolderLeave":
        this.contextMenuOpsService.leaveTeamFolder(this.universalService.currentTeamFolder);
        break;
      case "manageVersions":
          this.cleverTapEventsService.manageVerDownloadClicked();
          AppEvents.optionSelected.next({manageVersions: true});
          break;
      case 'openWithOfficeForWeb':
        var file = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile;
        var moduleType = this.fileOpsService.getModuleType(file);
        this.listService.deSelectAll(null);
        if(this.universalService.iframeLogin){
          var logincontroller = UserloginController.getInstance(this.globalService);
          var autoLoginUrl = await logincontroller.getAutoLogionToken();
          var token = autoLoginUrl["url"].split("?t=")[1];
          var msAuthUrl = "/a?t=" + token + "&msofficepreview=" + moduleType;
          window.open(msAuthUrl, "_blank", "noopener, noreferrer");
          return;
        }
        if(this.universalService.currentAlbum == undefined && (this.universalService.currentTab == 'Home' || this.router.url.includes('/filter/recents'))) {
          var fileOperController = FileOperationsController.getInstance(this.globalService);
          fileOperController.setEnvObjects(this.globalService);
          fileOperController.setAccessedDate(file);
          setTimeout(() => {
            AppEvents.emit(EventsList.UPDATE_RECENT);
          }, 500);
        }
        if(file["format"] == "SpreadSheet"){
          this.cleverTapEventsService.msOfficeClicked('Excel')
        }else if(file["format"] == "Document"){
          this.cleverTapEventsService.msOfficeClicked('Word')
        }else if(file["format"] == "Presentation"){
          this.cleverTapEventsService.msOfficeClicked('Powerpoint')
        }

        window.open(window.location.origin + '/document/editor/' + file["objectKey"] + "/" + moduleType , "_blank", "noopener, noreferrer");
        break;
      case 'openPreviewOptions':
        if(this.universalService.openMoreOptionsContextMenu){
          this.universalService.removeHighlightFromSelectedOption();
          this.universalService.openMoreOptionsContextMenu = false;
          this.contextMenuService.hideCustomMoreOptionsContextMenu();
        }else{
          this.universalService.highlightSelectedOption(action)
          this.universalService.openMoreOptionsContextMenu = true;
          this.contextMenuService.showCustomMoreOptionsContextMenu(event,0);
        }
        
        break;
      case "showFileLocation":
        if(this.universalService.selectedFile){
          let parentObject = this.universalService.selectedFile.parentObjectKey;
          this.fileOpsService.resetRequiredDataBeforeOpeningTheLocationOfSelectedFile();
          this.listService.deSelectAll();
          this.localStorageService.removeLocalProperty(LocalStorageProps.SEARCH_KEY)
          if(this.universalService.searchType == 'teamfolder'){
            this.sessionStorageService.setCurrentTeamFolder({folderKey:this.universalService.currentTeamFolder["objectKey"],tfKey:this.universalService.currentTeamFolder["tfKey"]});
            this.globalService.getFolderServiceRef().initialiseBreadCrumbs('1', this.universalService.rootTeamFolderName, null);
            this.globalService.getFolderServiceRef().manageBreadCrumbs(this.universalService.currentTeamFolder["objectKey"], this.universalService.currentTeamFolder["tfName"],this.universalService.currentTeamFolder, null);
            this.router.navigate(['/teamfolders', parentObject], { queryParams: { tfKey: this.universalService.currentTeamFolder["tfKey"] } , queryParamsHandling: 'merge'});
          }else{
            this.globalService.getFolderServiceRef().initialiseBreadCrumbs('1', this.universalService.rootFolderNameNew, null);
            this.router.navigate(["/allfiles", parentObject], {state:{"initBreadCrumbs" : true}});
          }
        }
        break;
      case "editPhoto":
        var file = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile;
        var moduleType = this.fileOpsService.getModuleType(file);
        moduleType = this.fileOpsService.setModuleDataForSavingTheEditedObject(file,moduleType,this.globalService.getFolderServiceRef().currentFolder)
        this.listService.deSelectAll(null);
        window.open(window.location.origin + '/jc-photo/editor/' + file["objectKey"] + "/" + moduleType, "_blank", "noopener, noreferrer");
        break;
      default:
        this.loggerService.log("option invalid")
    }
  }

  clickOutside(){
    if(!this.universalService.listView){
      this.universalService.showContextMenu = false
    }
  }

  getTeamFolderOperationsRoute(){
    this.universalService.currentTeamFolder = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile;
    return this.universalService.currentTeamFolder["objectKey"] + "*" + this.universalService.selectedFile["tfKey"];
  }

  enhancedShareLink() {
    AppEvents.optionSelected.next({showEnhancedShareLink:true});   
  }

  uploadFiles(){
    this.universalService.fileUploadMimeType = '';
    this.universalService.isUploadFromRecentlyUploadedSection = false; 
    if(!this.router.url.includes('/albums/')){
      this.universalService.isAlbumsView = false;
    }
    this.universalService.isUploadFromShare = false;
    AppEvents.emit(EventsList.UPLOAD_CLICKED);
  }
  

  uploadFolder(){
    this.universalService.isAlbumsView = false;
    this.universalService.isUploadFromShare = false;
    AppEvents.emit(EventsList.UPLOAD_FOLDER_CLICKED);
  }

  createNewFolder(){
    this.createFolder.emit();
    this.universalService.popUpToBeOpened = 'create Folder';
    AppEvents.globalObservable.next({createFolder:true});
  }
}